import { Cliente } from "../model/Cliente";
import { PropostaEsteira } from "../model/propostaEsteira";
import { RefinDTO } from "./refinDTO";
import { ResultadoSimulacaoPropostaDTO } from "./resultadoSimulacaoPropostaDTO";

export class PropostaDTO {
  public regime!: string;
  public idFidc?: number;
  public nomeFidc?: string;
  public fidcPendencia?: string;
  public taxaCessaoFidc?: number;
  public id!: number;
  
  public promotora!: string;
  public gerente!: string;
  public operador!: string;
  public pontoVenda!: string;
  public idOriginador!: number;

  public produto!: string; 
  public tipoProposta!: string;
  public empregador!: string;
  public orgao!: string;
  public cliente!: Cliente;
  public idCliente!: number;
  public cpfCliente!: string;
  public matriculaCliente!: string;
  public nomeCliente!: string;
  public dtNascimentoCliente!: Date;
  public tipoConta!: string;
  public banco!: string;
  public agencia!: string;
  public conta!: string;
  public contaDv!: string;
  public valorRMCUtilizado!: number;
  public valorLimite!: number;
  public limiteCompra!: number;
  public limiteSaque!: number;
  public tarifaEmissao!: number;
  public valorDespesas!: number;
  public valorTC!: number;
  public anuidade!: number;
  public valorMargemOnline!: number;
  public idUsuarioAnalise?: number | null; 
  public dataBloqueio?: string | null; 

  public taxaClAm!: number;
  public taxaClAa!: number;
  public taxaCetAm!: number;
  public taxaCetAa!: number;
  public taxaApAm!: number;
  public taxaApAa!: number;
  public taxaClSaqueAm!: number;
  public taxaClSaqueAa!: number;
  public valorSolicitado!: number;
  public valorIof!: number;
  public valorLiquido!: number;
  public valorParcela!: number;
  public valorBruto!: number;
  public valorPrincipal!: number;
  public valorFidc?: number | null;
  public agioOriginador?: number | null;
  public usuario!: string;
  public statusFormalizacao!: string;
  public isSucessoAtualizacaoForm!: boolean;
  public linkFormalizacao!: string;
  public telefoneCelular!: string;
  
  public simulacaoProposta!: ResultadoSimulacaoPropostaDTO;
  public prazo!: number;
  public dtPrimeiroVencimento!: Date;
  public dtUltimoVencimento!: Date;
  public dtAlteracao!: Date;
  public dataAlteracao!: string;
  public codigoTabela!: string;
	public tabela!: string;

  public financiamento!: string;

  public statusProposta!: string;
  public atividadeAtual!: string;
  public dtMovimentacao!: Date;
  public processoEsteira!: string;
  public pmt!: number;
  public numeroContrato!: string;
  public atividade!: string;

  public idFormalizacao!: string;
  public numeroContratoExterno!: string;
  public adeAverbacao!: string;
  public idEsteira!: string;

  public selected!: boolean;
  public dataCadastro!: Date;
  public isFinalizada!: boolean;
  public valorMaximoCompra!: number;
  public atividadesAnteriores!: Array<PropostaEsteira>;

  public numeroProposta!: string;
  public propostaCongelada!: boolean;
  public erro_proposta!: string;
  public tipoProduto!: string; 
}
